export default __webpack_public_path__ + "static/media/gallery_00.d1c31741.jpg";